import { render, staticRenderFns } from "./SimulationSolAgoraStep1.vue?vue&type=template&id=33dc01bc&scoped=true&"
import script from "./SimulationSolAgoraStep1.vue?vue&type=script&lang=js&"
export * from "./SimulationSolAgoraStep1.vue?vue&type=script&lang=js&"
import style0 from "./SimulationSolAgoraStep1.vue?vue&type=style&index=0&id=33dc01bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dc01bc",
  null
  
)

export default component.exports